import React from "react";
import "./Components.css";
import Button from "@material-ui/core/Button";
import Fab from "@material-ui/core/Fab";
import List from "@material-ui/core/List";
import { green, grey } from "@material-ui/core/colors";
import { ListItem, ListItemText, Avatar } from "@material-ui/core";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Chip from "@material-ui/core/Chip";
import {
  faTrash,
  faShoppingBasket,
  faShoppingCart
} from "@fortawesome/free-solid-svg-icons";

library.add(faTrash, faShoppingBasket, faShoppingCart);

const Cart = props => {
  if (props.selectedItems) {
    const items = props.selectedItems;
    let total = 0;
    items.forEach(item => {
      total += item.amount;
    });
    return (
      <div className="cart">
        <h2>
          {" "}
          <FontAwesomeIcon icon="shopping-cart" />
          &nbsp; Cart&nbsp;
        </h2>
        <div style={{ flexGrow: 1 }} />
        <List
          style={{
            height: 380,
            overflowY: "auto",
            boxShadow: "0px 0px 3px #ccc",
            backgroundColor: grey[100]
          }}
        >
          {items.map(item => (
            <ListItem style={{ backgroundColor: "white" }}>
              <Avatar style={{ backgroundColor: green[400] }}>
                <FontAwesomeIcon icon="shopping-basket" />
              </Avatar>
              <ListItemText
                primary={item.title}
                secondary={`${item.amount} QTY`}
              />
              <Button
                onClick={props.resetItem.bind(null, item.id)}
                color="secondary"
              >
                x
              </Button>
            </ListItem>
          ))}
        </List>
        <hr />
        <div style={{ display: "flex", margin: "14px" }}>
          <Chip
            color="primary"
            style={{ margin: "auto", fontSize: "1.3em" }}
            label={`Total: ${total} QTY`}
          />
        </div>
        <div style={{ display: "flex" }}>
          <span>
            <Fab
              onClick={props.reset}
              color="secondary"
              size="large"
              aria-label="Reset"
              style={{ marginRight: "auto" }}
            >
              <FontAwesomeIcon icon="trash" />
            </Fab>
          </span>

          {total > 0 ? (
            <Button
              size="large"
              color="default"
              variant="contained"
              onClick={props.checkout}
              style={{
                marginLeft: "auto",
                backgroundColor: "#2196f3",
                color: "white"
              }}
            >
              <FontAwesomeIcon icon="shopping-basket" />
              &nbsp; checkout
            </Button>
          ) : (
            <span />
          )}
        </div>
      </div>
    );
  }
  return <p />;
};

export default Cart;
